import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import { initialState } from '../redux';

export const loginSlice = createSlice({
  name: 'loginSlice',
  initialState,
  reducers: {
    loginRequest: (state) => {
      state.isLoading = true;
      state.error = false;
    },
    loginSuccess: (state, action) => {
      const { isAuthenticated, loginId, token, user } = action.payload;
      state.isAuthenticated = isAuthenticated;
      state.isLoading = false;
      state.token = token;
      state.user = user;
      state.loginId = loginId;
    },
    loginFailure: () => {
      const updatedState = {
        ...initialState.auth,
        error: true,
        uuid: uuidv4(),
      };

      return updatedState;
    },
    setLoginCurrentStep: (state, action) => {
      const { direction } = action.payload;

      state.loginCurrentStep =
        direction === 'forward'
          ? state.loginCurrentStep + 1
          : state.loginCurrentStep - 1;
    },
  },
});
